import { alpha, styled, TextField, TextFieldProps } from "@mui/material";

export type FormFieldProps = TextFieldProps & {
  inputBgColor?: string;
};

const FormField = styled(TextField)<FormFieldProps>(({ theme }) => ({
  width: "100%",

  "&:focus": {
    boxShadow: `${alpha(theme.palette.grey[300], 0.25)} 0 0 0 0.1rem`,
    borderColor: theme.palette.grey[300]
  },

  "label + &": {
    marginTop: theme.spacing(1)
  },

  "& .MuiInputBase-root": {
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 4,
    width: "100%",

    [theme.breakpoints.down("sm")]: {
      maxWidth: "none"
    }
  },

  "& .MuiFormHelperText-root": {
    marginTop: theme.spacing(1),
    marginLeft: 0
  },

  "& .MuiInputBase-root.Mui-error": {
    border: `1px solid ${theme.palette.error.main}`
  },

  "& .MuiInputBase-input": {
    position: "relative",
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.secondary,
    fontSize: "1rem",
    fontWeight: 500,
    padding: 16,
    boxShadow: "none",
    borderRadius: "4px",
    transition: theme.transitions.create(["border-color"])
  },

  "& .MuiInputBase-root .MuiOutlinedInput-notchedOutline": {
    border: "none"
  }
}));

export default FormField;
